export const ELEMENT_SIZE = {
  small: "small",
  medium: "medium",
  large: "large",
} as const;
